import React from 'react';

const CheckboxComponent = React.memo((props) => {
    return <>
    <div className={`check-box-component required ${props.invalid}`} >
    <label className="form-field" element="formField">
        
    <input element="input" type="checkbox" name={props.name} id={props.id} className="slot-content" value="" onClick = {props.onClickFunction} defaultChecked={props.checked}/>
        <div className="label" element="label">{props.label} <a href={props.link} target='_blank'>{props.linktext}</a></div>
        </label>
        <span className="message" element="message">{props.error}</span>
        </div>
    </>
});
export default CheckboxComponent;
